/**
 * XR ECS components and tags.
 */

import { defineComponent, defineTag } from '../ecs/Component.js';
import { ComponentType } from '../shared/types.js';

/** Tag: entity is tracked by XR (controller or hand). */
export const XRTracked = defineTag('XRTracked');

/** Tag: entity is anchored to the real world via XRAnchor. */
export const XRAnchored = defineTag('XRAnchored');

/** Component: XR controller metadata. */
export const XRController = defineComponent('XRController', {
  handedness: ComponentType.String,    // 'left' | 'right' | 'none'
  targetRayMode: ComponentType.String, // 'gaze' | 'tracked-pointer' | 'screen'
  hasHand: ComponentType.Boolean,      // true if hand tracking active
});
